<template>
  <div class="avecor-table" >
    <v-toolbar dense style="border-top:1px solid #ccc;position:fixed;top:70px;width:100%;background:#FFF !important;z-index:20;border-bottom:1px solid #ccc;"  flat class="pr-4">
      <v-toolbar-title >Muut tunnukset</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-text-field
          :value="otherPartnersSearchTerm"
          @change="(event) => otherPartnersSearchTerm = event"
          class="table-search avecor-select"
          label="Etsi tästä"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn @click="addOtherPartnerDialog=true" dark class="avecor-button-global add-button mb-2" color="#000000">Lisää tunnus</v-btn>
      <AddOtherPartner @close="addOtherPartnerDialog=false" :visible="addOtherPartnerDialog" ></AddOtherPartner>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="getOtherPartners"
      hide-default-footer
      :expand="true"
      :fixed-header="true"
      :search="otherPartnersSearchTerm"
      :dense="true"
      disable-pagination
      height="85.7vh"
      style="padding-top:85px;"
      :options="{itemsPerPage:-1}"
    >
      <template v-slot:item="props">
        <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
        <tr style="height:25px;" class="hide-field-details">
          <td class="text-center" style="width:80px;">
            <v-icon 
              :size="10"
              @click="deleteItem(props.item)"
            >
              far fa-trash-alt
            </v-icon>
          </td>
          <td style="min-width:75px">
            <v-text-field
                slot="activator"
                class="avecor-date-picker"  
                :value="props.item.created_at ? customFormatter(props.item.created_at) : ''"
                readonly
            ></v-text-field>
          </td>
          
          <td class="text-xs-left" style="min-width:200px;">
            <v-text-field
              :value="props.item.name"
              @change="v => inlineSaveField(props.item.id,'name',v)"
              class="avecor-select"
            ></v-text-field>
          </td>
          <td class="text-xs-left" style="min-width:200px;">
            <v-textarea
              :value="props.item.usedFor"
              @change="v => inlineSaveField(props.item.id,'usedFor',v)"
              single-line
              rows=1
              :auto-grow="true"
              class="avecor-select"
            ></v-textarea>
          </td>
          <td class="text-xs-left" style="min-width:200px;">
            <v-text-field
              :value="props.item.address"
              @change="v => inlineSaveField(props.item.id,'address',v)"
              class="avecor-select"
            ></v-text-field>
          </td>
          <td class="text-xs-left" style="min-width:200px;">
            <v-text-field
              :value="props.item.webAddress"
              @change="v => inlineSaveField(props.item.id,'webAddress',v)"
              class="avecor-select"
            ></v-text-field>
          </td>
          <td class="text-xs-left" style="min-width:25px;">
            <v-btn v-if="props.item.webAddress !== undefined && props.item.webAddress !== ''" :href="props.item.webAddress" text target="_blank">
              <v-icon size=12>fas fa-external-link-alt</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-left" style="min-width:150px;">
            <v-text-field
              :value="props.item.username"
              @change="v => inlineSaveField(props.item.id,'username',v)"
              class="avecor-select"
            ></v-text-field>
          </td>
          <td class="text-xs-left" style="min-width:100px;">
            <v-text-field
              :value="props.item.password"
              @change="v => inlineSaveField(props.item.id,'password',v)"
              class="avecor-select"
            ></v-text-field>
          </td>
          <td class="text-xs-left" style="min-width:150px;">
            <v-textarea
              :value="props.item.supportEmail"
              @change="v => inlineSaveField(props.item.id,'supportEmail',v)"
              single-line
              rows=1
              :auto-grow="true"
              class="avecor-select"
            ></v-textarea>
          </td>
          <td style="min-width:200px;">
            <v-textarea
              :value="props.item.contacts"
              @change="v => inlineSaveField(props.item.id,'contacts',v)"
              single-line
              rows=1
              :auto-grow="true"
              class="avecor-select"
            ></v-textarea>
          </td>
          <td style="min-width:200px;">
            <v-textarea
              :value="props.item.comments"
              @change="v => inlineSaveField(props.item.id,'comments',v)"
              single-line
              rows=1
              :auto-grow="true"
              class="avecor-select"
            ></v-textarea>
          </td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import AddOtherPartner from './AddOtherPartner'

export default {
    components: {
      AddOtherPartner
    },
    data: () => ({
      isEditing: false,
      selected: ["Avecor Oy"],
      selections: {},
      dialog: false,
      addOtherPartnerDialog: false,
      selectedOrderId: null,
      selectedProductId: null,
      table: null,
      search: '',
      headers: [
        { text: ' ', value: '', align: 'center', sortable: false },
        { text: 'Lisätty pvm.', value: 'created_at', align: 'left', sortable: true},
        { text: 'Nimike', value: 'name', align: 'left', sortable: true},
        { text: 'Mitä tekee', value: 'usedFor', align: 'left', sortable: true},
        { text: 'Osoite', value: 'address', align: 'left', sortable: true},
        { text: 'www-osoite', value: 'webAddress', align: 'left', sortable: true},
        { text: 'linkki', value: '', align: 'center', sortable: false},
        { text: 'Käyttäjätunnus', value: 'username', align: 'left', sortable: true},
        { text: 'Salasana', value: 'password', align: 'left', sortable: true},
        
        { text: 'Sähköposti', value: 'supportEmail', align: 'left', sortable: true},
        { text: 'Yhteyshenkilöt', value: 'contacts', align: 'left', sortable: true},
        
        
        { text: 'Kommentit/Ohjeet', value: 'comments', align: 'left', sortable: false},
      ],
      date: new Date().toISOString().substr(0, 10)
    }),
    watch: {

    },
    mounted() {
      const table = this.$refs.table
    },
    computed: {
      getOtherPartners(){
        var otherPartners = this.otherPartners
        return Object.keys(this.otherPartners).map(function(key, index) {
          return otherPartners[key]
        })
      },
      ...mapFields([
        "settings",
        "user",
        'otherPartner.otherPartners',
        "settings.otherPartnersSearchTerm",
      ])
    },
    created () {},

    methods: {
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      deleteItem (item) {
        console.log(item)
        if (confirm('Haluatko varmasti poistaa?')) {
          this.$store.dispatch('otherPartner/delete', item.id)
        }
      },
      inlineSaveField(id,field,value){
        this.$store.dispatch('otherPartner/set', {
          id,
          [field]:value
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/OtherPartnersTable.vue